import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';
import { Button, useMediaQuery } from '@spothero/ui';
import SpotListItemBase from 'common/spot-card-base/v2';
import FacilitySummary from 'common/facility-summary/v2';
import { push as pushTo } from 'store/router/router-actions';
import { showSpotsLeft } from 'utils/spot-left';
import { setSpotDetailReferrer as setSpotDetailReferrerTo, isExpressCheckoutEligible, } from 'store/spot/spot-actions';
import DynamicSpotListItemButton from '../spot-card-dynamic-CTA-button';
import { FACILITY_SUMMARY_VIEW_TYPES } from 'common/facility-summary/utils';
import { useDispatch, useSelector } from 'react-redux';
import { routeToSpotDetails } from 'router/router-utils';
import AirportCardTransportation from './AirportSpotTransportation';
import AirportSpotTag from './AirportSpotTag';
import { IMMEDIATE_FEATURES } from 'utils/experiment';
import { useFeatureVariation } from 'plugins/optimizely/hooks/use-feature-variation';
import useConfig from 'hooks/use-config';
import AirportDistance from './AirportDistance';
export const SpotListItemAirport = ({ spot, isActive, isHighlighted, isAdmin, isRebookingReservation, updateSelectedSpot, onShowDetailsClick, onBookSpotClick, referer = 'list', optimizely, }) => {
    const { isMobile } = useConfig();
    const dispatch = useDispatch();
    const { location } = useHistory();
    const { spotId, availability, facilityType, spotDetailsUrl, transportation, tag, } = spot;
    const { available, availableSpaces } = availability;
    const containerClasses = classNames({ 'SpotListItem-active': isActive }, { 'SpotListItem-hovered': isHighlighted }, { unavailable: !available });
    const storeState = useSelector((state) => state);
    const { searchRequest } = storeState;
    const showLatestDesignForAirport = useFeatureVariation(IMMEDIATE_FEATURES.AIRPORT_UNIFIED_DESIGN_UPDATE) === 'on';
    const handleShowDetailsClick = evt => {
        evt.preventDefault();
        evt.stopPropagation();
        setSpotDetailReferrerTo(referer);
        routeToSpotDetails({
            method: (...args) => dispatch(pushTo(...args)),
            location,
            spotId,
            historyState: { referrer: referer },
        });
        if (onShowDetailsClick) {
            onShowDetailsClick({ spotId });
        }
        if (showLatestDesignForAirport) {
            routeToSpotDetails({
                method: (...args) => dispatch(pushTo(...args)),
                location,
                spotId,
                historyState: { referrer: referer },
            });
        }
        else {
            if (isMobile) {
                dispatch(pushTo(spotDetailsUrl));
            }
            else {
                window.open(spotDetailsUrl, '_blank');
            }
        }
    };
    const handleBookSpotClick = evt => {
        evt.preventDefault();
        evt.stopPropagation();
        const { selectedRate: { expressCheckoutUrl }, } = spot;
        const shouldSend = isExpressCheckoutEligible({
            spot,
            searchRequest,
            isRebookingReservation,
            isAdmin,
            eventPackage: null,
            optimizely,
        });
        if (onBookSpotClick) {
            onBookSpotClick({ spotId });
        }
        updateSelectedSpot({
            spot,
            referrer: referer,
            goToSpotUrl: true,
            optimizely,
        });
        const oldCheckoutUrl = spotDetailsUrl.replace('airport-parking', 'checkout');
        if (shouldSend) {
            window.location.href = expressCheckoutUrl;
        }
        else {
            pushTo(oldCheckoutUrl);
        }
    };
    const isShowSpotsLeftVisible = showSpotsLeft({
        available,
        availableSpaces,
        facilityType,
    });
    const [isDeviceSmallerThan360px] = useMediaQuery('(max-width: 360px)');
    const showImages = useMemo(() => !isDeviceSmallerThan360px, [
        isDeviceSmallerThan360px,
    ]);
    return (<SpotListItemBase spotId={spotId} additionalClasses={containerClasses} onClick={handleShowDetailsClick} MainContent={<FacilitySummary 
        // @ts-ignore
        spot={spot} showImages={showImages} AirportTag={<AirportSpotTag tag={tag} title={spot.title} spotsLeft={isShowSpotsLeftVisible ? availableSpaces : null}/>} isAdmin={isAdmin} isShowSpotsLeftVisible={isShowSpotsLeftVisible} view={FACILITY_SUMMARY_VIEW_TYPES.SPOT_LIST} AirportDistance={<AirportDistance spot={spot}/>} AirportTransportationInfo={<AirportCardTransportation type={transportation?.type || ''}/>} CTAs={<>
                            <Button variant="tertiary" onClick={handleShowDetailsClick} display={!available ? 'none' : 'inline-flex'}>
                                Details
                            </Button>
                            <DynamicSpotListItemButton isAdmin={isAdmin} available={available} isRebookingReservation={isRebookingReservation} isHovered={isHighlighted} onClick={handleBookSpotClick}/>
                        </>}/>}/>);
};
export default React.memo(SpotListItemAirport);
